module.exports = __webpack_public_path__ + "files/f782411c8a5693604b82961e80ea697f.png";